import { FC, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import MainRouters from '../Routes/MainRouters';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';

const Navigator: FC = () => {
  const { login, initHideBar } = useActions();
  const { enqueueSnackbar } = useSnackbar();
  const error = useTypedSelector(state => state.global.error);

  useEffect(() => {
    error &&
      enqueueSnackbar(`${error?.status} ${error?.result}`, {
        variant: 'error'
      });
  }, [error]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const isHideNavbar = localStorage.getItem('isNavBar');
    token && login();
    isHideNavbar === 'true' && initHideBar();
  }, []);

  return (
    <>
      <MainRouters />
    </>
  );
};
export default Navigator;
